import { render, staticRenderFns } from "./HospitalPage.vue?vue&type=template&id=75edcdd0&scoped=true"
import script from "./HospitalPage.vue?vue&type=script&lang=js"
export * from "./HospitalPage.vue?vue&type=script&lang=js"
import style0 from "./HospitalPage.vue?vue&type=style&index=0&id=75edcdd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75edcdd0",
  null
  
)

export default component.exports